import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CartItem } from '../types/store';

type PublicCartSidebarProps = {
  isOpen: boolean;
  cartItems: CartItem[];
  onClose: () => void;
  onRemoveItem: (itemId: string) => void;
  onCheckout?: () => void;
};

export default function PublicCartSidebar({
  isOpen,
  cartItems,
  onClose,
  onRemoveItem,
  onCheckout,
}: PublicCartSidebarProps) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    document.body.classList.add('cart-open');
    return () => {
      document.body.classList.remove('cart-open');
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const cartTotal = cartItems.reduce((sum, item) => sum + item.quantity * item.unitPrice, 0);

  return createPortal(
    <>
      <button type="button" className="cart-sidebar-backdrop" onClick={onClose} aria-label="Cerrar carrito" />
      <aside className="cart-sidebar" aria-label="Carrito de compras">
        <div className="cart-sidebar-header">
          <h3>Carrito de compras</h3>
          <button type="button" className="cart-sidebar-close" onClick={onClose} aria-label="Cerrar carrito">
            ✕
          </button>
        </div>

        <div className="cart-sidebar-body">
          {cartItems.length === 0 ? (
            <div className="cart-sidebar-empty">
              <span className="cart-sidebar-empty-icon" aria-hidden="true">
                🛒
              </span>
              <p>Aun no tienes productos en el carrito.</p>
            </div>
          ) : (
            cartItems.map((item) => (
              <article key={item.id} className="cart-item-card">
                <div className="cart-item-thumb">
                  {item.image ? (
                    <img src={item.image} alt={item.name} />
                  ) : (
                    item.icon || '💊'
                  )}
                </div>
                <div className="cart-item-content">
                  <p className="cart-item-name">{item.name}</p>
                  <p className="subtitle">Cantidad: {item.quantity}</p>
                  <p className="cart-item-subtotal">S/. {(item.quantity * item.unitPrice).toFixed(2)}</p>
                </div>
                <button
                  type="button"
                  className="cart-item-remove"
                  aria-label={`Eliminar ${item.name}`}
                  onClick={() => onRemoveItem(item.id)}
                >
                  ✕
                </button>
              </article>
            ))
          )}
        </div>

        <div className="cart-sidebar-footer">
          <div className="cart-sidebar-total">
            <strong>Total</strong>
            <strong>S/. {cartTotal.toFixed(2)}</strong>
          </div>
          {cartItems.length > 0 && onCheckout ? (
            <button type="button" className="cart-checkout-button" onClick={onCheckout}>
              Finalizar pedido
            </button>
          ) : null}
        </div>
      </aside>
    </>,
    document.body
  );
}
